module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', [_c('div', {
    staticClass: "value-wrapper"
  }, [_c('div', {
    staticClass: "value-line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("\n                        Budgetteret\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.totals[0])) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "value-line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("\n                        Realiseret\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.totals[1])) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "value-line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("\n                        Difference\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "right",
    class: {
      'good': _vm.totals[2] > 0, 'bad': _vm.totals[2] < 0
    }
  }, [(_vm.totals[2] > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(_vm.totals[2])) + "\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "32px",
      "padding-bottom": "16px"
    }
  }, [_vm._v("\n            Fordeling:  \n            "), _c('div', {
    staticClass: "employee-switcher"
  }, [_c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.divisionOption === 1
    },
    on: {
      "click": function($event) {
        _vm.divisionOption = 1
      }
    }
  }, [_vm._v("\n                    Budgetlinjer\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.divisionOption === 2
    },
    on: {
      "click": function($event) {
        _vm.divisionOption = 2
      }
    }
  }, [_vm._v("\n                    Opgavetyper\n                ")])])])]), _vm._v(" "), _c('minuba-budget-report-linetypes', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.divisionOption === 1),
      expression: "divisionOption === 1"
    }],
    attrs: {
      "rows": _vm.lineTypes,
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('minuba-budget-report-projecttypes', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.divisionOption === 2),
      expression: "divisionOption === 2"
    }],
    attrs: {
      "rows": _vm.projectTypes,
      "loading": _vm.loading
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-753288f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/projects/components/minubaBudgetReport.vue
// module id = 901
// module chunks = 0